import React from "react";

import { useLocation } from "react-router-dom";

import { PageTransition } from "~/components/layout/PageTransition";
import { AppSidebar } from "~/components/layout/sidebar/AppSidebar";
import { TopBar } from "~/components/layout/topbar/TopBar";
import { cn } from "~/lib/utils";
import { UserRole } from "~/types/user";

// Routes that stretch to the full viewport width instead of the 1600px cap
// (multi-column boards that users zoom out to see in full).
const FULL_WIDTH_ROUTES = ["/sales-notes"];

interface MainLayoutContentProps {
  children: React.ReactNode;
  userRole: UserRole;
  pageTitle?: string;
}

export function MainLayoutContent({
  children,
  userRole,
}: MainLayoutContentProps) {
  const { pathname } = useLocation();
  const isFullWidth = FULL_WIDTH_ROUTES.includes(pathname);

  return (
    <>
      <AppSidebar userRole={userRole} />
      <div className="md:hidden">
        <TopBar />
      </div>
      <div className="relative flex w-full min-w-0 flex-1 flex-col bg-background transition-all duration-200">
        <div className="flex w-full min-w-0 flex-1 justify-center bg-gray-50 pb-8 pt-24 md:pt-8">
          <main
            className={cn(
              "w-full min-w-0 px-4 sm:px-6 lg:px-8",
              !isFullWidth && "max-w-[1600px]"
            )}
          >
            <PageTransition>{children}</PageTransition>
          </main>
        </div>
      </div>
    </>
  );
}
